import React from 'react';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafeComponent from '../shared/SafeComponent';
import Card from './Card';
import categoriesData from './config';

import './style.scss';

const Categories = () => (
    <div className="main-categories lohp-row">
        <h2><I18n k="logged_out_homepage.categories.title"/></h2>
        <ul className="categories-list">
            {
                categoriesData.map((categoryData, index) => (
                    <Card key={index} {...categoryData} position={index + 1}/>
                ))
            }
        </ul>
    </div>
);

export { Categories };
export default SafeComponent(Categories);
